/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_You_DescInputs */

const en_terms_section_2_term_you_desc = /** @type {(inputs: Terms_Section_2_Term_You_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any person or organisation using this website or our services.`)
};

const lv_terms_section_2_term_you_desc = /** @type {(inputs: Terms_Section_2_Term_You_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jebkura persona vai organizācija, kas izmanto šo tīmekļvietni vai mūsu pakalpojumus.`)
};

/**
* | output |
* | --- |
* | "Any person or organisation using this website or our services." |
*
* @param {Terms_Section_2_Term_You_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_you_desc = /** @type {((inputs?: Terms_Section_2_Term_You_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_You_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_you_desc(inputs)
	return en_terms_section_2_term_you_desc(inputs)
});